import React, { useState } from 'react';
import useStore from '../../../store';
import { mainThemes, archiveThemes, archive2Themes, bestThemes } from '../themes/registry';
import '../MafiaOverlay.css';
import '../themes/index.css';

const MafiaThemeSelector = () => {
  const { menu } = useStore.getState().ref;
  const [activeTab, setActiveTab] = useState('test'); // Default: 'best'

  let currentList = bestThemes;
  if (activeTab === 'test') currentList = mainThemes;
  if (activeTab === 'archive2') currentList = archive2Themes;
  if (activeTab === 'archive1') currentList = archiveThemes;

  return (
    <div className="mafia-overlay-bg">
        <div style={{
            width: '90%',
            maxWidth: '380px',
            height: '85vh',
            backgroundColor: '#1a1a1a',
            borderRadius: '24px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            boxShadow: '0 20px 50px rgba(0,0,0,0.8)',
            border: '1px solid #333',
            position: 'relative'
        }}>

            {/* Хедер с табами */}
            <div style={{
                padding: '20px 20px 10px 20px',
                backgroundColor: '#222',
                borderBottom: '1px solid #333',
                zIndex: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: '15px'
            }}>
                <h2 style={{ margin: 0, color: 'white', fontSize: '18px', textAlign: 'center', fontWeight: 800 }}>
                    ВЫБОР СТИЛЯ
                </h2>

                <div style={{ display: 'flex', background: '#111', borderRadius: '12px', padding: '4px', border: '1px solid #333', gap: '2px', overflowX: 'auto' }}>
                    <button
                        onClick={() => setActiveTab('best')}
                        style={{
                            flex: 1, padding: '8px 4px', borderRadius: '8px', border: 'none',
                            background: activeTab === 'best' ? '#fbbf24' : 'transparent',
                            color: activeTab === 'best' ? '#fff' : '#888',
                            fontWeight: 'bold', fontSize: '11px', cursor: 'pointer', transition: 'all 0.2s',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        ЛУЧШИЕ ({bestThemes.length})
                    </button>
                    <button
                        onClick={() => setActiveTab('test')}
                        style={{
                            flex: 1, padding: '8px 4px', borderRadius: '8px', border: 'none',
                            background: activeTab === 'test' ? '#40a7e3' : 'transparent',
                            color: activeTab === 'test' ? '#fff' : '#888',
                            fontWeight: 'bold', fontSize: '11px', cursor: 'pointer', transition: 'all 0.2s',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        ТЕСТ ({mainThemes.length})
                    </button>
                    <button
                        onClick={() => setActiveTab('archive2')}
                        style={{
                            flex: 1, padding: '8px 4px', borderRadius: '8px', border: 'none',
                            background: activeTab === 'archive2' ? '#7c4dff' : 'transparent',
                            color: activeTab === 'archive2' ? '#fff' : '#888',
                            fontWeight: 'bold', fontSize: '11px', cursor: 'pointer', transition: 'all 0.2s',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        АРХИВ 2 ({archive2Themes.length})
                    </button>
                    <button
                        onClick={() => setActiveTab('archive1')}
                        style={{
                            flex: 1, padding: '8px 4px', borderRadius: '8px', border: 'none',
                            background: activeTab === 'archive1' ? '#555' : 'transparent',
                            color: activeTab === 'archive1' ? '#fff' : '#888',
                            fontWeight: 'bold', fontSize: '11px', cursor: 'pointer', transition: 'all 0.2s',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        АРХИВ 1 ({archiveThemes.length})
                    </button>
                </div>
            </div>

            {/* Скролл контент */}
            <div className="add-scroll" style={{
                flex: 1,
                overflowY: 'auto',
                padding: '15px',
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '12px',
                alignContent: 'start'
            }}>
                {currentList.map(theme => (
                    <div
                        key={theme.id}
                        onClick={() => menu.methods.setTheme(theme.id)}
                        style={{
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            transition: 'transform 0.1s'
                        }}
                        onMouseDown={e => e.currentTarget.style.transform = 'scale(0.96)'}
                        onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}
                        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                    >
                        {/* Превью */}
                        <div
                            className={`mafia-generic-card theme-${theme.id}`}
                            style={{
                                width: '100%',
                                minHeight: '120px',
                                height: 'auto',
                                fontSize: '6px',
                                pointerEvents: 'none',
                                margin: 0,
                                transform: 'none',
                                animation: 'none',
                                borderRadius: '12px'
                            }}
                        >
                            <div className="mpc-header team-mafia" style={{ padding: '8px 4px' }}>
                                <div className="mpc-icon" style={{ fontSize: '20px', marginBottom: '2px' }}>🎭</div>
                                <div className="mpc-title" style={{ fontSize: '8px' }}>{theme.name}</div>
                            </div>
                            <div className="mpc-content" style={{ padding: '4px', justifyContent: 'center' }}>
                                <div className="mpc-target-word" style={{ fontSize: '10px', padding: '2px 4px', margin: '2px 0' }}>
                                    WORD
                                </div>
                            </div>
                            <div className="mpc-button" style={{ margin: '0 8px 8px 8px', padding: '4px 0', fontSize: '8px' }}>
                                OK
                            </div>
                        </div>

                        <div style={{ color: '#888', fontSize: '11px', marginTop: '6px', fontWeight: 500 }}>
                            {theme.desc}
                        </div>
                    </div>
                ))}
            </div>

            {/* Тень снизу */}
            <div style={{
                position: 'absolute', bottom: 0, left: 0, right: 0, height: '20px',
                background: 'linear-gradient(to top, rgba(26,26,26, 1), transparent)', pointerEvents: 'none'
            }}/>
        </div>
    </div>
  );
};

export default MafiaThemeSelector;